/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { mergeAttributes } from "@tiptap/core";
import { createColGroup } from "./create-col-group";
import { selectColumn } from "./select-column";
import { removeColumnWidth } from "./remove-column-width";

/**
 * @typedef {import("@tiptap/extension-table").TableOptions} Options
 * @typedef {import("@tiptap/core").NodeConfig<Options>} TableNodeConfig

 */

/** @type {TableNodeConfig} */
const tableNodeConfig = {
    addCommands () {
        return {
            ...this.parent(),
            selectColumn,
            removeColumnWidth
        };
    },
    renderHTML ({ node, HTMLAttributes }) {
        const { colgroup } = createColGroup(
            node,
            this.options.cellMinWidth,
        );

        /** @type {import("@tiptap/pm/model").DOMOutputSpec} */
        const table = [
            "table",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {}),
            colgroup,
            ["tbody", 0],
        ];

        return table;
    },
};

export { tableNodeConfig };
